export function toQueryString( obj ) {
    const parts = [];
    for ( let i in obj ) {
        if ( obj.hasOwnProperty( i ) ) {
            parts.push( encodeURIComponent( i ) + "=" + encodeURIComponent( obj[i] ) );
        }
    }
    return parts.join( "&" );
}